import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleWidgets } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc CallManagementListsWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CallManagementListsWidgetService } from 'services/callManagementListsWidget';
 *
 * // create service instance and send/cancel request
 * const callManagementListsWidgetService = new CallManagementListsWidgetService();
 * const result = await callManagementListsWidgetService.fetchData( '<user-id>' ); // fetch data
 * callManagementListsWidgetService.cancel(); // cancel an active request
 */
export class CallManagementListsWidgetService extends HttpService {

    // make request and fetch widgets to display
    async fetchWidgets( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            // extract widgets from the response
            const componentData = get( response, 'body.component', {} );
            const widgets = getVisibleWidgets( componentData );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    widgets,
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
